var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStepsTickComplete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16C0.5 7.43959 7.43959 0.5 16 0.5C24.5604 0.5 31.5 7.43959 31.5 16C31.5 24.5604 24.5604 31.5 16 31.5C7.43959 31.5 0.5 24.5604 0.5 16Z",
    stroke: "#4678EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1437 10.25H21.8955C21.7205 10.25 21.5544 10.3304 21.4473 10.4679L14.0848 19.7946L10.5544 15.3214C10.501 15.2536 10.4329 15.1988 10.3553 15.1611C10.2777 15.1233 10.1925 15.1037 10.1062 15.1036H8.85799C8.73835 15.1036 8.67228 15.2411 8.74549 15.3339L13.6366 21.5304C13.8651 21.8196 14.3044 21.8196 14.5348 21.5304L23.2562 10.4786C23.3294 10.3875 23.2633 10.25 23.1437 10.25Z",
    fill: "#4678EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsTickComplete);
export default __webpack_public_path__ + "static/media/steps-tick-complete.f51d76cbb5a07cc7b280970e6149ecfa.svg";
export { ForwardRef as ReactComponent };